import { createFileRoute } from '@tanstack/react-router'
import MarketingAutomacoesPage from '@/pages/dashboard/marketing-automacoes-page'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/automacoes/',
)({
  component: function MarketingAutomacoesIndexRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.AUTOMACOES} dashboardId={dashboardId}>
        <MarketingAutomacoesPage />
      </RequireModule>
    )
  },
})
